import {
  IValidatorRules,
  registerValidateLocale,
  registerValidateRules,
  setValidateLanguage
} from '@formily/validator'

import { toBig } from '@eastcoal/common/utils/decimal'
import { isEmpty } from '@eastcoal/common/utils/object'

export const setupFormily = () => {
  setValidateLanguage('zh-CN')

  registerValidateLocale({
    'zh-CN': {
      // {{ field.title }}
      required: '{{ field.title }}不能为空',
      precision: '{{ field.title }}最多保持 {{precision}} 位小数',
      minium: '{{ field.title }}必须大于等于 {{minimum}}',
      exclusiveMinimum: '{{ field.title }}必须大于 {{exclusiveMinimum}}',
      maxium: '{{ field.title }}必须小于等于 {{maxium}}',
      exclusiveMaxium: '{{ field.title }}必须小于 {{exclusiveMaxium}}'
    }
  })

  registerValidateRules({
    required(value: any, rule: IValidatorRules<any>) {
      if (rule.required === false) return ''

      let flag = isEmpty(value)

      if (!flag && typeof value === 'object') {
        const keys = Object.keys(value)
        flag = keys.every(key => isEmpty(value[key]))
      }

      return flag ? (rule.message ?? '') : ''
    },
    precision(value: any, rule: IValidatorRules<any>) {
      if (isEmpty(value)) {
        return ''
      }

      // 原生浮点乘法存在精度误差（如 1.12 * 10000 = 11200.000000000002），改用 Big 十进制运算判断：
      // 值四舍五入到 precision 位小数后与原值相等，说明小数位不超过 precision
      return toBig(value).round(Number(rule.precision)).eq(toBig(value))
        ? ''
        : (rule.message ?? '')
    }
  })
}
